export interface Region {
  id: number;
  name: string;
  icon: PaymentMethodImage;
  secondaryCurrency: string | null;
  slug: string;
}

export enum UserWalletType {
  CARD = 1,
  PHONE_NUMBER = 2,
  EMAIL = 3,
  CRYPTO_WALLET = 4,
  STEAMID = 5,
  SIMPLE_WALLET = 6
}

export const enum InvoiceType {
  REDIRECT = 1,
  MESSAGE = 2,
  ERROR = 3,
  STRIPE_ELEMENT = 4
}

export type Invoice = {
  type: InvoiceType;
  data: string;
};

export interface PaymentMethod {
  id: number;
  name: string;
  icon: PaymentMethodImage | null;
  needWallet: boolean;
  needAmount: boolean;
  walletType: UserWalletType | null;
  currencyCode: string;
  minAmount: number;
  maxAmount: number;
  badge: string | null;
  informer: string | null;
  animatedIconName: string | null;
  linkToTab: string | null;
  gameIds: number[] | null;
  isGiftCode: boolean;
  isSpecific: boolean;
}

export interface Tab {
  id: number;
  name: string;
  slug: string;
  icon: string;
  banner: PaymentMethodImage;
  description: string | null;
  descriptionTitle: string | null;
  title: string | null;
  methods: PaymentMethod[];
  type: TabType;
}

export type TabType = Extract<PaymentTabs, 'default' | 'crypto' | 'skins' | 'gifts'>;

export interface PaymentMethodImage {
  fileName: string;
}

export interface Payment {
  id: number;
  method: PaymentMethod | null;
  status: PaymentStatus;
  amountUsd: string;
  bonusesTotalUsd: string;
  createdAt: string;
}

export enum PaymentTabs {
  DEFAULT = 'default',
  CRYPTO = 'crypto',
  SKINS = 'skins',
  GIFTS = 'gifts',
  STEAM = 'steam',
  LIS = 'lis',
  GGPAY = 'ggpay',
  REFERRAL = 'referral',
  HORIZON = 'card_withdrawal',
}

export enum PaymentSection {
  DEPOSIT = 'Deposit',
  WITHDRAWAL = 'Withdrawal',
}

export const enum PaymentStatus {
  CREATED = 1,
  PAID = 2,
  EXPIRED = 3,
  REFUNDED = 4,
  DECLINED = 5
}

export interface MoneyMethods {
  descriptionTitle: string | null;
  methods: PaymentMethod[];
  name: string;
  icon: string;
  banner: PaymentMethodImage;
  description: string | null;
  id: number;
  title: string | null;
  slug: string;
}

export namespace PaymentApiResponse {
  export interface Regions {
    regions: Region[];
    detectedRegion: Region;
  }

  export interface GiftCodes {
    codes: PaymentMethod[];
  }

  export interface PaymentInvoice {
    invoice: Invoice;
  }

  export interface PaymentMethods {
    methods: PaymentMethod[];
  }

  export interface RegionTabs {
    tabs: Tab[];
    tabTypes: TabType[];
    skinsMethods: PaymentMethod[];
  }

  export interface PaymentHistory {
    payments: Payment[];
  }

  export interface GiftCodeApplied {}
}
